import React from 'react';
import {
  Button,
  CondensedMedium,
  CondensedSmall,
  DateUtil,
  Flashy,
  Gutter,
  useApi,
  Well,
} from '@axiom/ui';
import type { Account, AfcSubmission } from '@axiom/validation';

import { InstantMatchesApi } from '../../api/instant-matches-api';
import { AccountIntakeApi } from '../../api/account-intake-api';
import { SubmissionApi } from '../../api/submission-api';

export type RefreshInstantMatchesProps = {
  account: Account;
  submissionId: AfcSubmission['submissionId'];
};

export const RefreshInstantMatches = ({
  account,
  submissionId,
}: RefreshInstantMatchesProps) => {
  const [{ data: intakeData }] = useApi(
    AccountIntakeApi.readAccountIntake(account.id, { submissionId })
  );
  return (
    <Gutter top="16px">
      <Well background="light" name="refresh-matches-well">
        <Button
          name="refresh-matches-button"
          icon="reset"
          pattern="secondary"
          variation="outline"
          onClick={async () => {
            await InstantMatchesApi.updateInstantMatches(submissionId);
            await InstantMatchesApi.refreshInstantMatches(submissionId);
            await AccountIntakeApi.refreshAccountIntake(account.id);
            await SubmissionApi.refreshSubmissionDetails(submissionId);
          }}
        >
          Refresh Matches
        </Button>
        <Gutter vertical="8px">
          <CondensedMedium>
            Refresh your matches to see currently available talent. Pin any
            talent you want to save before refreshing.
          </CondensedMedium>
        </Gutter>
        {intakeData?.instantMatchesRefreshedAt ? (
          <Flashy bold>
            <CondensedSmall>{`Last refreshed: ${DateUtil.displayRelativeTime(intakeData.instantMatchesRefreshedAt)}`}</CondensedSmall>
          </Flashy>
        ) : null}
      </Well>
    </Gutter>
  );
};
